import "./App.css";
import {
  createBrowserRouter,
  RouterProvider,
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginComponent from "./components/Login/LoginComponent";
import GyaaniApp from "./modules/gyaani/GyaaniApp";
import PartnersApp from "./modules/partners/PartnersApp";
import GyanniClients from "./modules/gyaani/pages/Clients/GyanniClients";
import GyanniOrg from "./modules/gyaani/pages/Organization/GyanniOrg";
import GyanniUsers from "./modules/gyaani/pages/Users/GyanniUsers";
import GyanniMstRole from "./modules/gyaani/pages/MstRole/GyanniMstRole";
import GyanniMstModule from "./modules/gyaani/pages/MstModule/GyanniMstModule";
import GyanniUserRole from "./modules/gyaani/pages/UserRole/GyanniUserRole";
import GyanniMapModule from "./modules/gyaani/pages/MapModule/GyanniMapModule";
import LlmModuleInventory from "./modules/gyaani/pages/LLMModuleInventory/LlmModuleInventory";
import GyanniBulkUserUpload from "./modules/gyaani/pages/BulkUserUpload/GyanniBulkUserUpload";
import AgenticEUCApp from "./modules/agentic-euc/AgenticEUCApp";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPassword from "./components/ForgotPassword";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginComponent />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/GYAANi",
    element: (
      <PrivateRoute>
        <GyaaniApp />
      </PrivateRoute>
    ),
    children: [
      {
        path: "clients",
        element: (
          <PrivateRoute>
            <GyanniClients />
          </PrivateRoute>
        ),
      },
      {
        path: "organization",
        element: (
          <PrivateRoute>
            <GyanniOrg />
          </PrivateRoute>
        ),
      },
      {
        path: "users",
        element: (
          <PrivateRoute>
            <GyanniUsers />
          </PrivateRoute>
        ),
      },
      {
        path: "MSTRole",
        element: (
          <PrivateRoute>
            <GyanniMstRole />
          </PrivateRoute>
        ),
      },
      {
        path: "MstModule",
        element: (
          <PrivateRoute>
            <GyanniMstModule />
          </PrivateRoute>
        ),
      },
      {
        path: "UserRoleAction",
        element: (
          <PrivateRoute>
            <GyanniUserRole />
          </PrivateRoute>
        ),
      },
      {
        path: "MapModuleRoleUserAction",
        element: (
          <PrivateRoute>
            <GyanniMapModule />
          </PrivateRoute>
        ),
      },
      {
        path: "LlmModelConfiguration",
        element: (
          <PrivateRoute>
            <LlmModuleInventory />
          </PrivateRoute>
        ),
      },
      {
        path: "BulkUserUpload",
        element: (
          <PrivateRoute>
            <GyanniBulkUserUpload />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/Partners",
    element: (
      <PrivateRoute>
        <PartnersApp />
      </PrivateRoute>
    ),
  },
  {
    path: "/agentic-EUC",
    element: (
      <PrivateRoute>
        <AgenticEUCApp />
      </PrivateRoute>
    ),
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer />
    </>
  );

  //   <BrowserRouter>
  //   <div>
  //     <Routes>
  //       <Route path="/" element={<Speechanalysis socket={socket} />}></Route>
  //       <Route path="/agentDashboard" element={<AgentApp socket={socket} />}></Route>
  //     </Routes>
  //   </div>
  // </BrowserRouter>
}

export default App;
